import { render, staticRenderFns } from "./ProfileReport.vue?vue&type=template&id=45bc7e28&scoped=true"
import script from "./ProfileReport.vue?vue&type=script&lang=js"
export * from "./ProfileReport.vue?vue&type=script&lang=js"
import style0 from "./ProfileReport.vue?vue&type=style&index=0&id=45bc7e28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bc7e28",
  null
  
)

export default component.exports